<template>
    <div>

        <div class="title">
            <h3>Os campos com * são de preenchimento obrigatório</h3>
            <h5>Caso queira, você poderá salvar e continuar depois.</h5>
         </div>

         <div class="formulario">
              <div class="agrupamentoFormulario">
                <div class="categoriaAgrupamentoFormulario">

<LabelDisclaimer :TamanhoFonteLabel="'H5'" :NomeLabel="'FATCA'" :TipoCliente="'Fundos'" :Sessao="'FATCA'" :SubSessao="'FATCA'"/>

                  <span>Foreign Account Tax Compliance Act</span>
                </div>
                <div class="camposAgrupamentoFormulario">

                  <div class="row">
                    <div class="label__field" style="width: 80%">
                      <label class="label" for="nome">É instituição Financeira Estrangeira (FFI) aderente ao FATCA?</label>
<div class="radio">
                                            <input
                                              type="radio"
                                              id="Facta"
                                              value="false"
                                              name="Facta"
                                              class="field__radio"
                                              v-model="localFI.Facta"
                                               @change="salvarAlteracoesLocalmente"
                                            />
                                            <label
                                                for="nao"
                                                class="label__radio"
                                            >
                                                Não
                                            </label>

                                            <input
                                              type="radio"
                                              id="Facta"
                                              value="true"
                                              name="Facta"
                                              class="field__radio"
                                              v-model="localFI.Facta"
                                               @change="salvarAlteracoesLocalmente"
                                            />
                                            <label
                                                for="simRJI"
                                                class="label__radio"
                                            >
                                                Sim
                                            </label>


                                           </div>

                    </div>

                  </div>



                  <div class="row">
                    <div class="label__field" style="width: 60%">
                      <label class="label" for="nome">Se sim, informar o Nº GIIN:</label>
                      <input class="field" type="text" @change="salvarAlteracoesLocalmente" v-model="localFI.NumeroGiin" id="NumeroGiin" placeholder="">
                    </div>
                  </div>


                  <div class="row">
                    <div class="label__field" style="width: 60%">
                      <label class="label" for="nome">Caso não o possua o Nº GIIN, informar os motivos:</label>
                      <textarea v-model="localFI.NumeroGiinMotivos"  @change="salvarAlteracoesLocalmente" style="width: 100%; height: 80px; max-height: 120px;" class="field"></textarea>
                    </div>
                  </div>


                  <div class="row">
                    <div class="label__field" style="width: 80%">
                      <label class="label" for="nome">Tem sede ou Filial nos EUA?</label>
                        <div class="radio">

                                            <input
                                              type="radio"
                                              id="SedeEua_Nao"
                                              value="false"
                                              name="SedeEua"
                                              class="field__radio"
                                              v-model="localFI.SedeEua"
                                               @change="salvarAlteracoesLocalmente"
                                            />
                                            <label
                                                for="SedeEua_Nao"
                                                class="label__radio"
                                            >
                                                Não
                                            </label>

                                            <input
                                              type="radio"
                                              id="SedeEua_Sim"
                                              value="true"
                                              name="SedeEua"
                                              class="field__radio"
                                              v-model="localFI.SedeEua"
                                               @change="salvarAlteracoesLocalmente"
                                            />

                                            <label for="SedeEua_Sim" class="label__radio">
                                                Sim
                                            </label>


                                           </div>
                                        </div>
                                      </div>


                  
                                    <div class="row">
                    <div class="label__field" style="width: 80%">
                      <label class="label" for="nome">É Sociedade Constituída sob a Legislação dos EUA?</label>
                        <div class="radio">

                                            <input
                                              type="radio"
                                              id="SociedadeEua_false"
                                              value="false"
                                              name="SociedadeEua"
                                              class="field__radio"
                                              v-model="localFI.SociedadeEua"
                                               @change="salvarAlteracoesLocalmente"
                                            />
                                            <label
                                                for="SociedadeEua_false"
                                                class="label__radio"
                                            >
                                                Não
                                            </label>

                                            <input
                                              type="radio"
                                              id="SociedadeEua_true"
                                              value="true"
                                              name="SociedadeEua"
                                              class="field__radio"
                                              v-model="localFI.SociedadeEua"
                                               @change="salvarAlteracoesLocalmente"
                                            />
                                            <label
                                                for="SociedadeEua_true"
                                                class="label__radio"
                                            >
                                                Sim
                                            </label>


                                           </div>

                    </div>
                  </div>

                                                      <div class="row">
                    <div class="label__field" style="width: 80%">
                      <label class="label" for="nome">Possui vínculo societário com alguma instituição estrangeira?</label>
<div class="radio">

                                            <input
                                              type="radio"
                                              id="false"
                                              value="false"
                                              name="VinculoSocietarioEstrangeiro"
                                              class="field__radio"
                                              v-model="localFI.VinculoSocietarioEstrangeiro"
                                               @change="salvarAlteracoesLocalmente"
                                            />
                                            <label
                                                for="nao"
                                                class="label__radio"
                                            >
                                                Não
                                            </label>

                                            <input
                                              type="radio"
                                              id="true"
                                              value="true"
                                              name="VinculoSocietarioEstrangeiro"
                                              class="field__radio"
                                              v-model="localFI.VinculoSocietarioEstrangeiro"
                                               @change="salvarAlteracoesLocalmente"
                                            />
                                            <label
                                                for="simRJI"
                                                class="label__radio"
                                            >
                                                Sim
                                            </label>


                                           </div>

                    </div>

                  </div>

                  
                 <div class="row">
                    <div class="label__field" style="width: 60%">
                      <label class="label" for="nome">Se sim, quais país(es)?</label>
                      <textarea v-model="localFI.VinculoSocietarioEstrangeiroEspecificacao"  @change="salvarAlteracoesLocalmente" style="width: 100%; height: 80px; max-height: 120px;" class="field"></textarea>


                    </div>

                  </div>

                 <div class="row">
                    <div class="label__field" style="width: 80%">
                      <label class="label" for="nome">Possui alguma fonte de renda em Mercado Estrangeiro?</label>
                              <div class="radio">

                                            <input
                                              type="radio"
                                              id="FonteRendaMercadoEstrangeiro_false"
                                              value="false"
                                              name="FonteRendaMercadoEstrangeiro"
                                              class="field__radio"
                                              v-model="localFI.FonteRendaMercadoEstrangeiro"
                                               @change="salvarAlteracoesLocalmente"
                                            />
                                            <label
                                                for="FonteRendaMercadoEstrangeiro_false"
                                                class="label__radio"
                                            >
                                                Não
                                            </label>


                                            <input
                                              type="radio"
                                              id="FonteRendaMercadoEstrangeiro_true"
                                              value="true"
                                              name="FonteRendaMercadoEstrangeiro"
                                              class="field__radio"
                                              v-model="localFI.FonteRendaMercadoEstrangeiro"
                                               @change="salvarAlteracoesLocalmente"
                                            />
                                            <label
                                                for="FonteRendaMercadoEstrangeiro_true"
                                                class="label__radio"
                                            >
                                                Sim
                                            </label>


                                           </div>

                    </div>

                  </div>


                                        <div class="row">
                    <div class="label__field" style="width: 60%">
                      <label class="label" for="nome">Se sim, quais país(es)?</label>
                      <textarea v-model="localFI.FonteRendaMercadoEstrangeiroEspecificacao"  @change="salvarAlteracoesLocalmente" style="width: 100%; height: 80px; max-height: 120px;" class="field"></textarea>


                    </div>

                  </div>


                                                                                          <div class="row">
                    <div class="label__field" style="width: 80%">
                      <label class="label" for="nome">Possui conta corrente com movimentação no exterior?</label>
<div class="radio">

                                            <input
                                              type="radio"
                                              id="ContaCorrenteExterior_false"
                                              value="false"
                                              name="ContaCorrenteExterior"
                                              class="field__radio"
                                              v-model="localFI.ContaCorrenteExterior"
                                               @change="salvarAlteracoesLocalmente"
                                            />
                                            <label
                                                for="ContaCorrenteExterior_false"
                                                class="label__radio"
                                            >
                                                Não
                                            </label>

                                            <input
                                              type="radio"
                                              id="ContaCorrenteExterior_true"
                                              value="true"
                                              name="ContaCorrenteExterior"
                                              class="field__radio"
                                              v-model="localFI.ContaCorrenteExterior"
                                               @change="salvarAlteracoesLocalmente"
                                            />
                                            <label
                                                for="ContaCorrenteExterior_true"
                                                class="label__radio"
                                            >
                                                Sim
                                            </label>


                                           </div>

                    </div>

                  </div>


                                        <div class="row">
                    <div class="label__field" style="width: 60%">
                      <label class="label" for="nome">Se sim, quais país(es)?</label>
                      <textarea v-model="localFI.ContaCorrenteExteriorEspecificacao"  @change="salvarAlteracoesLocalmente" style="width: 100%; height: 80px; max-height: 120px;" class="field"></textarea>


                    </div>

                  </div>



                                                                                          <div class="row">
                    <div class="label__field" style="width: 80%">
                      <label class="label" for="nome">Possui, entre seus sócios/acionistas, cidadão americano (U.S Person)?</label>
<div class="radio">

                                              <input
                                              type="radio"
                                              id="SociosCidadaAmericano_false"
                                              value="false"
                                              name="SociosCidadaAmericano"
                                              class="field__radio"
                                              v-model="localFI.SociosCidadaAmericano"
                                               @change="salvarAlteracoesLocalmente"
                                            />
                                            <label
                                                for="simRJI"
                                                class="label__radio"
                                            >
                                                Não
                                            </label>

                                              <input
                                              type="radio"
                                              id="SociosCidadaAmericano_true"
                                              value="true"
                                              name="SociosCidadaAmericano"
                                              class="field__radio"
                                              v-model="localFI.SociosCidadaAmericano"
                                               @change="salvarAlteracoesLocalmente"
                                            />
                                            <label
                                                for="nao"
                                                class="label__radio"
                                            >
                                                Sim
                                            </label>

                                            



                                           </div>

                    </div>

                  </div>



                </div>
              </div>
              

            <RepresentanteFatca />

         </div>

          <div class="footerFormulario">

            <div class="buttonsAcoes">
              <button class="btnDefault" @click="salvarInformacoes" v-if="this.Edicao != true">Salvar e continuar depois</button>
              <button class="btnDefault" @click="salvarInformacoes" v-if="this.Edicao == true">Salvar</button>
              <button class="btnBlue" :disabled="!permitirAvancar" :class="{ disabledProximaEtapa: !permitirAvancar }" v-if="!Edicao" @click="proximaEtapa">Avançar</button>
            </div>

          </div>

    </div>
</template>


<script>

import { mapGetters } from 'vuex';
import RepresentanteFatca from './representante-fatca.vue';
import LabelDisclaimer  from '../Utilitarios/Disclaimer/LabelDisclaimer.vue'

export default {
    name: 'CadastroOutros_OutrasInformacoes',
      components: { RepresentanteFatca, LabelDisclaimer},
      props: ['informacoesDeclaracoes','Edicao'],
      computed: {
        ...mapGetters({
            user: 'auth/user'
        }),
    },
    data() {
      return {
        permitirAvancar: false,
        localFI: this.informacoesDeclaracoes,
        nomeEmpresa: ''
      }
    },
    mounted()
    {
      this.nomeEmpresa = process.env.VUE_APP_NOME_EMPRESA;
      this.validarFormulario();
    },
    methods: {
      validarFormulario()  {
        this.permitirAvancar = true;
      },
      proximaEtapa(){
        this.validarFormulario();
        
        if(this.permitirAvancar)
        {
          this.$store.commit('SET_ETAPA_CADASTRO', 8);
          this.$store.commit('SET_SALVAR_INFO_DES_NOTIFICACAO', true);
          this.salvarInformacoes();
        }
      },
      salvarInformacoes(){
        this.$store.commit('SET_FI_SALVAR_INFO', true);
      },
      salvarAlteracoesLocalmente(){
        this.$store.commit('SET_FI_SALVAR_INFO_DECLARACAO', this.localFI);
        this.validarFormulario();
      },

    }
}

</script>


<style lang="scss" scoped>

@import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600&display=swap');



.formulario{
  width: 100%;
}

.agrupamentoFormulario{
  width: 100%;
  display: inline-flex;
  margin-top: 10px;
  border-bottom: 1px solid #D0D5DD; /* Borda */

}

.categoriaAgrupamentoFormulario{
  width: 13%;
  margin-right: 15px;
  font-family: 'Inter', sans-serif; /* Fonte Inter */

  span{
    font-weight: 400 !important;
    font-size: 13px;
    color: #667085;
  }

}

.label__field{
  padding-right: 30px;
}

.camposAgrupamentoFormulario{
  width: 90%;

  .row{
    width: 100%;
    display: inline-flex;
    gap: 8px;
    margin-bottom: 10px;
  }

                  .accept {
                    display: inline-flex;

                    &:checked {
                      +label {
                            &:before {
                                background: white;
                                border: 1px solid black;
                                transition: background 0.3s;
                            }
                        }

                        +label {
                            &::after {
                                opacity: 1;
                                transition: all;
                                background: transparent;
                            }
                        }
                    }
                }



 .radio {
                display: flex;
                align-items: center;
                margin-right: 25px;

                @media (max-width: 768px) {
                    margin-right: 0;
                    margin-bottom: 20px;
                }

                .field__radio {
                    width: 20px;
                    height: 20px;
                }

                .fieldInRadio{
    border-radius: 8px; /* Raio de borda */
    border: 1px solid #D0D5DD; /* Borda */
    padding: 10px 14px; /* Preenchimento interno */
    background-color: #F9FAFB; /* Cor de fundo */
    width: 55%;
                }

                .label__radio {
                    margin-left: 5px;
                    margin-right: 40px;
                    margin-top: 5px;
                }
            }

select{
  width: 105% !important;
}


label {
    font-family: 'Inter', sans-serif; /* Fonte Inter */
    font-weight: 500; /* Peso médio */
    font-size: 14px; /* Tamanho da fonte */
    line-height: 20px; /* Altura da linha */
    color: #344054; /* Cor */
    display: block; /* Garante que a label fique acima do input */
    margin-bottom: 8px; /* Espaçamento entre a label e o input abaixo dela */
}

}





.title{

  border-bottom: 1px solid #EAECF0;

  h3{
    margin-top: 50px;
    color: #101828;
    font-weight: 500;
    font-family: 'Inter', sans-serif;
    
  }

  h5{
    margin-top: 5px;
    margin-block-start: 0;
    color: #667085;
    font-weight: 400;
    font-family: 'Inter', sans-serif;
  }
}


</style>